"use client";

import { Reveal } from "../reveal";
import { Button } from "../ui/button";
import { Download } from "lucide-react";
import { toast } from "sonner";
import type { LegalDocument } from "./legalDocument.type";

export function Hero({ doc }: { doc: LegalDocument }) {
  const { title, updatedAt } = doc;

  const downloadPDF = async () => {
    const element = document.getElementById("legal-doc-content");
    if (!element) return;

    toast.info("Generating PDF...");

    const opt = {
      margin: 1,
      filename: `${title.split(" ").join("-")}.pdf`,
      pagebreak: { mode: 'avoid-all' },
      image: { type: "jpeg" as const, quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" as const },
    };

    const html2pdf = (await import("html2pdf.js")).default;

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        toast.success("PDF downloaded successfully!");
      })
      .catch(() => {
        toast.error("Failed to generate PDF");
      });
  };

  const convertISODateToLocaleDate = (iso: string) => {
    const date = new Date(iso);

    const localeDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    return localeDate;
  };

  return (
    <section className=" -mb-60 -top-[254px] lg:-top-[300px] pt-24 bg-primary-900  w-full overflow-hidden relative before:content-[''] before:absolute before:left-0 before:-top-20 before:w-1/2 before:h-full before:bg-[url('/index/hero/right.svg')] before:bg-no-repeat before:bg-cover before:transform before:-scale-x-100 after:content-[''] after:absolute after:right-0 after:-top-20 after:w-1/2 after:h-full after:bg-[url('/index/hero/right.svg')] after:bg-no-repeat after:bg-cover">
      <div className="max-w-screen-2xl mx-auto overflow-hidden z-[2] relative before:absolute before:content-[''] before:w-full before:h-full before:bg-[url('/index/hero/center.svg')] before:bg-contain before:bg-center before:bg-no-repeat pt-[130px] sm:pt-[140px] before:top-0 lg:min-h-screen lg:flex lg:flex-col lg:justify-center">
        <Reveal>
          <div className="container mx-auto px-6 py-16 text-center">
            <h1 className="text-3xl lg:text-7xl md:text-6xl font-bold mb-4 text-white">
              {title}
            </h1>
            <p className="text-muted-foreground mb-8">
              Last updated: {convertISODateToLocaleDate(updatedAt)}
            </p>
            <Button
              onClick={downloadPDF}
              variant="default"
              radius="full"
              className="w-full xs:w-fit mt-4"
              asChild={false}
              size={"xl"}
            >
              <Download className="h-4 w-4" />
              Download PDF
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
